import type { FC, SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const SolidArrowIcon: FC<Props> = (props) => (
  <svg width="24" height="14" {...props}>
    <path d="M22.966 0H1l3 3 2.493 3.75 5.492 6.75 5.49-6.75L20 3l2.966-3Z" />
    <path d="M.873 0a3 3 0 0 1 2.433 1.244l7.883 10.924a1 1 0 0 0 1.622 0l7.883-10.924A3 3 0 0 1 23.127 0v1a2 2 0 0 0-1.622.83l-7.883 10.923a2 2 0 0 1-3.244 0L2.495 1.83A2 2 0 0 0 .873 1V0Z" />
  </svg>
);
